module.exports = __webpack_public_path__ + "static/media/video6.23352c0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/video6.mp4
// module id = G1AD
// module chunks = 1